import { Controller } from "@hotwired/stimulus"

// Calendrier-like : pastilles de jours scrollables + grille d'horaires
// du jour actif. Clic sur un jour → recharge la grille. Clic sur un
// créneau → renseigne l'input hidden.
export default class extends Controller {
  static targets = [
    "dayPill", "slotsGrid", "slot", "input", "hint",
    "dateLabel", "slotsCount"
  ]

  connect() {
    // Sélectionne le 1er jour disponible par défaut + filtre la grille.
    if (this.hasDayPillTarget) {
      const first = this.dayPillTargets.find((p) => p.classList.contains("is-active"))
                 || this.dayPillTargets[0]
      if (first) this._activateDay(first.dataset.date, first.textContent.trim())
    }

    // Intercepte le submit du form parent : si aucun créneau n'est sélectionné,
    // on bloque, on fait clignoter le hint, et on scroll jusqu'à la grille.
    // Évite que le visiteur arrive sur "Préféré ne peut pas être vide" côté
    // serveur sans comprendre quel champ manque.
    const form = this.element.closest("form")
    if (form && !form.dataset.consultSlotGuardBound) {
      form.dataset.consultSlotGuardBound = "1"
      form.addEventListener("submit", (e) => {
        if (!this.hasInputTarget) return
        if (this.inputTarget.value && this.inputTarget.value.trim() !== "") return
        e.preventDefault()
        if (this.hasHintTarget) {
          this.hintTarget.textContent = "Choisissez un horaire avant de continuer."
          this.hintTarget.classList.add("is-error")
          // Retire la classe après un moment pour pouvoir re-trigger l'effet.
          setTimeout(() => this.hintTarget.classList.remove("is-error"), 2000)
        }
        if (this.hasSlotsGridTarget) {
          this.slotsGridTarget.scrollIntoView({ behavior: "smooth", block: "center" })
        } else {
          this.element.scrollIntoView({ behavior: "smooth", block: "center" })
        }
      })
    }
  }

  pickDay(event) {
    const btn = event.currentTarget
    this.dayPillTargets.forEach((p) => p.classList.remove("is-active"))
    btn.classList.add("is-active")
    this._activateDay(btn.dataset.date)
    this._updateLabelFromPill(btn)
    this._clearSelection()
  }

  pick(event) {
    const btn = event.currentTarget
    this._clearSelection()
    btn.classList.add("is-active")
    if (this.hasInputTarget) this.inputTarget.value = btn.dataset.iso
    if (this.hasHintTarget) {
      const label = btn.textContent.trim()
      this.hintTarget.textContent = `Créneau sélectionné : ${label}`
      this.hintTarget.classList.add("is-confirmed")
    }
  }

  _activateDay(isoDate) {
    if (!this.hasSlotTarget) return
    let visible = 0
    this.slotTargets.forEach((btn) => {
      const match = btn.dataset.date === isoDate
      btn.style.display = match ? "" : "none"
      if (match) visible += 1
    })
    if (this.hasSlotsCountTarget) {
      this.slotsCountTarget.textContent = `${visible} créneau${visible > 1 ? "x" : ""}`
    }
    if (this.hasHintTarget) {
      this.hintTarget.classList.remove("is-confirmed")
      this.hintTarget.textContent = visible > 0
        ? "Cliquez un horaire pour le sélectionner."
        : "Pas de créneau disponible ce jour-là."
    }
  }

  _updateLabelFromPill(pillBtn) {
    if (!this.hasDateLabelTarget) return
    // Recompose "Lundi 25 mai" depuis les <span> internes.
    const wd = pillBtn.querySelector(".consult-cal-day-wd")?.textContent?.replace(".", "") || ""
    const num = pillBtn.querySelector(".consult-cal-day-num")?.textContent || ""
    const mo = pillBtn.querySelector(".consult-cal-day-mo")?.textContent || ""
    const txt = `${wd} ${num} ${mo}`.trim()
    if (txt) this.dateLabelTarget.textContent = txt
  }

  _clearSelection() {
    if (this.hasSlotTarget) {
      this.slotTargets.forEach((b) => b.classList.remove("is-active"))
    }
    if (this.hasInputTarget) this.inputTarget.value = ""
  }
}
